import { render, staticRenderFns } from "./ExaminationDetailPage.vue?vue&type=template&id=afd1d7da&scoped=true&"
import script from "./ExaminationDetailPage.vue?vue&type=script&lang=js&"
export * from "./ExaminationDetailPage.vue?vue&type=script&lang=js&"
import style0 from "./ExaminationDetailPage.vue?vue&type=style&index=0&id=afd1d7da&prod&lang=scss&"
import style1 from "./ExaminationDetailPage.vue?vue&type=style&index=1&id=afd1d7da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afd1d7da",
  null
  
)

export default component.exports